<template>
  <div>
    <div class="flex justify-between mb-1" v-if="label">
      <label class="block text-sm font-medium leading-5 text-gray-700">{{
        label
      }}</label>
      <span class="text-sm leading-5 text-gray-500" v-if="required">
        {{ $t ? $t('sqrd_ui_required') : 'Required' }}
      </span>
    </div>
    <div class="relative rounded-md shadow-sm">
      <div
        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
      >
        <span class="text-gray-500 sm:text-sm sm:leading-5">
          {{ (value && value.currency) || currency }}
        </span>
      </div>
      <input
        class="flex-1 block w-full px-3 py-2 rounded-md sm:text-sm sm:leading-5 border border-gray-300 transition duration-150 ease-in-out focus:outline-none focus:shadow-outline-blue focus:border-blue-300 pr-12"
        v-bind="$attrs"
        v-on="sqrListeners"
        :value="amount"
        @change="amountSet('change', $event)"
        @input="amountSet('input', $event)"
        :class="inputClass"
        type="text"
        inputmode="decimal"
      />
    </div>
    <slot name="invalid" v-if="v && v.$error">
      <p class="mt-1 text-xs text-red-600" v-if="!v.required">
        {{ label }} is required.
      </p>
      <p class="mt-1 text-xs text-red-600" v-if="!v.between">
        {{ label }} is not between {{ v.$params.between.min }} and
        {{ v.$params.between.max }}.
      </p>
    </slot>
  </div>
</template>

<style src="./SqrInput.postcss" lang="postcss" scoped></style>

<script>
import SqrInput from './SqrInput';
export default {
  name: 'SqrdInputAmount',
  mixins: [SqrInput],
  props: {
    value: Object,
    currency: { type: String, default: 'CHF' },
    precision: { type: Number, default: 2 }
  },
  computed: {
    amount() {
      const raw = this.value?.amount ?? 0;
      const precision = this.value?.precision ?? this.precision ?? 0;
      const amount = raw / Math.pow(10, precision);
      return amount;
    }
  },
  methods: {
    amountSet(eventName, event) {
      const rawValue = event.target.value;
      const precision = this.precision;
      if (rawValue.match(/^\.$/)) return;
      const unformated = rawValue.replace(/[^.\d]+/g, '');
      let amount = undefined;
      if (unformated.length > 0 && unformated.match(/^\d*\.?\d*$/)) {
        const float = parseFloat(unformated);
        amount = Math.round(float * Math.pow(10, this.precision));
      } else {
        amount = 0;
      }
      console.log(eventName, rawValue, unformated, amount);
      if (Number.isNaN(amount)) {
        amount = undefined;
      }
      const baseObjectValue = typeof this.value === 'object' ? this.value : {};
      const currency = this.currency;
      const value = { ...baseObjectValue, precision, amount, currency };
      this.$emit(eventName, value);
    }
  }
};
</script>
